import React, { useMemo } from 'react';
import { View, Text, StyleSheet } from 'react-native';
import { useAppTheme } from '../contexts/ThemeContext';

const STATUS_CONFIG = {
  draft:    { label: 'Draft',    color: '#94A3B8', bg: 'rgba(148,163,184,0.10)', border: 'rgba(148,163,184,0.20)' },
  sent:     { label: 'Sent',     color: '#4F7EF8', bg: 'rgba(79,126,248,0.10)',  border: 'rgba(79,126,248,0.25)' },
  accepted: { label: 'Accepted', color: '#22C55E', bg: 'rgba(34,197,94,0.10)',   border: 'rgba(34,197,94,0.25)' },
  declined: { label: 'Declined', color: '#F43F5E', bg: 'rgba(244,63,94,0.10)',   border: 'rgba(244,63,94,0.25)' },
  unpaid:   { label: 'Unpaid',   color: '#F59E0B', bg: 'rgba(245,158,11,0.10)',  border: 'rgba(245,158,11,0.25)' },
  paid:     { label: 'Paid',     color: '#22C55E', bg: 'rgba(34,197,94,0.10)',   border: 'rgba(34,197,94,0.25)' },
  overdue:  { label: 'Overdue',  color: '#F43F5E', bg: 'rgba(244,63,94,0.12)',   border: 'rgba(244,63,94,0.30)' },
};

export default function StatusBadge({ status, size = 'md' }) {
  const { typography } = useAppTheme();
  const config = STATUS_CONFIG[status] || STATUS_CONFIG.draft;

  return (
    <View
      style={[
        styles.badge,
        {
          backgroundColor: config.bg,
          borderColor: config.border,
          paddingHorizontal: size === 'sm' ? 8 : 10,
          paddingVertical: size === 'sm' ? 2 : 4,
        },
      ]}
    >
      <View style={[styles.dot, { backgroundColor: config.color }]} />
      <Text
        style={[
          styles.label,
          {
            color: config.color,
            fontSize: size === 'sm' ? 10 : typography.sizes.xs,
          },
        ]}
      >
        {config.label}
      </Text>
    </View>
  );
}

const styles = StyleSheet.create({
  badge: {
    flexDirection: 'row',
    alignItems: 'center',
    borderRadius: 999,
    borderWidth: 1,
    alignSelf: 'flex-start',
  },
  dot: {
    width: 5,
    height: 5,
    borderRadius: 3,
    marginRight: 5,
  },
  label: {
    fontWeight: '700',
    letterSpacing: 0.5,
    textTransform: 'uppercase',
  },
});
